// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { Box, List } from 'grommet'
import { Search as SearchIcon } from 'grommet-icons'
import PropTypes from 'prop-types'

import { Typography } from '../../../../components'

const ListComponent = ({ content, handleListClick }) => {
  return (
    <List
      data={content?.items}
      onClickItem={(item) => {
        handleListClick(item.item)
      }}
      eventType="item-select"
      pad="none"
      data-testid="autocomplete-list"
    >
      {(datum, index) => (
        <Box
          gap="small"
          pad={{ horizontal: 'xsmall', vertical: 'small' }}
          direction="row"
          align="center"
          alignContent="center"
          key={index}
          data-testid={`autocomplete-list-${index}`}
        >
          <SearchIcon id="search-icon" size="small" />
          <Typography type="text" testId={`autocomplete-label-${index}`}>
            {datum}
          </Typography>
        </Box>
      )}
    </List>
  )
}

ListComponent.propTypes = {
  content: PropTypes.any.isRequired,
  handleListClick: PropTypes.func.isRequired
}

export { ListComponent }
